import './Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-item">&copy;2022</div>
      <a href="https://github.com/AnastasiyaPoleshuk" className="footer-item">Anastasiya Poleshuk</a>
    </footer>
  );
};

export default Footer;
